import { FC, useMemo } from 'react';
import { Image, Link, Stack } from '@chakra-ui/react';

import okHandImg from 'assets/brand/ok-hand@2x.png';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

import { Request } from '../../../../hooks/useRequests';
import { usePaymentCardRequestFees } from '../../hooks/usePaymentCardRequestFees';
import locales from './locales';

interface RequestApprovedProps {
  request: Request;
}

const RequestApproved: FC<RequestApprovedProps> = ({ request }) => {
  const { fees } = usePaymentCardRequestFees(request.type);

  const feesText = useMemo(() => {
    if (!fees) {
      return '';
    }

    const monthlyFeeWithouVat = fees.monthly.priceWithoutVAT;
    const orderFeeWithouVat = fees.order.priceWithoutVAT;

    if (monthlyFeeWithouVat && orderFeeWithouVat) {
      return locales.formatString(locales.fees.all, {
        monthlyFee: monthlyFeeWithouVat,
        orderFee: orderFeeWithouVat,
      });
    }

    if (monthlyFeeWithouVat) {
      return locales.formatString(locales.fees.onlyMonthly, {
        monthlyFee: monthlyFeeWithouVat,
      });
    }

    if (orderFeeWithouVat) {
      return locales.formatString(locales.fees.onlyOrder, {
        orderFee: orderFeeWithouVat,
      });
    }

    return undefined;
  }, [fees]);

  return (
    <Stack spacing="space-16">
      <Image alt="" boxSize="120px" role="presentation" src={okHandImg} />

      <Heading>{locales.title}</Heading>

      {request.requester ? (
        <Text>
          {locales.formatString(locales.description, request.requester)}
        </Text>
      ) : null}

      {feesText ? <Text>{feesText}</Text> : null}

      <Link
        as="a"
        // there is no english version available at the moment
        href="https://www.shine.fr/tarifs"
        rel="noopener noreferrer"
        target="_blank"
      >
        {locales.costs}
      </Link>
    </Stack>
  );
};

export default RequestApproved;
